/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import axios from "axios";
import type { AxiosInstance } from "axios";
import AxiosCommon from "helpers/axios/AxiosCommon";
import store from "helpers/store";
import { setError } from "helpers/actions";
import { ROOT_API } from "helpers/config";

export function createAxiosInstance(): AxiosInstance {
    const ajax = axios.create({
        baseURL: ROOT_API,
        headers: {
            Accept: "application/json",
        },
    });

    AxiosCommon.applyRequestInterceptor(ajax, setError, store);
    AxiosCommon.applyResponseInterceptor(ajax, setError, store);

    return ajax;
}

let defaultInstance: AxiosInstance | null = null;

export function getDefaultInstance(): AxiosInstance {
    if (!defaultInstance) {
        defaultInstance = createAxiosInstance();
    }
    return defaultInstance;
}

export default new Proxy({} as AxiosInstance, {
    get(_, prop) {
        return getDefaultInstance()[prop as keyof AxiosInstance];
    },
});
